<template>
  <v-container fluid>
    <template>
      <v-card :loading="loading">
        <v-card-title>
          <h2>
            <v-btn
              depressed
              class="mx-2"
              icon
              text
              small
              :to="{ name: 'contas-receber-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span v-if="loading">Carregando...</span>
            <template v-else>
              <span>Alterar contas a receber: {{ fatura }}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-card-text>
            <v-menu
              v-model="menuDataParcela"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataParcela"
                  :error-messages="dataParcelaErrors"
                  label="Data Vencimento"
                  prepend-icon="mdi mdi-calendar"
                  readonly
                  v-on="on"
                  clearable
                  @input="$v.dataParcela.$touch()"
                  @blur="$v.dataParcela.$touch()"
                ></v-text-field>
              </template>
              <button-datepicker
                v-model="data_parcela"
                @input="menuDataParcela = false"
              />
            </v-menu>

            <v-select
              :items="formaPgtoContaBancaria"
              label="Conta Bancária"
              return-object
              item-value="id"
              v-model="formaPgtoContaBancariaSelecionada"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{
                    item.descricao_forma_pagamento
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.descricao_conta_bancaria }}
                    <BR />
                    Ag:
                    {{ item.agencia }} CC: {{ item.conta }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <template v-slot:selection="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{
                    item.descricao_forma_pagamento
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.descricao_conta_bancaria }}
                    <BR />
                    Ag:
                    {{ item.agencia }} CC: {{ item.conta }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                
              </template>
            </v-select>
           {{this.forma_pgto}}
            <v-file-input
                  v-if="this.forma_pgto == 'BOLETO'"
                  show-size
                  clearable
                  v-model="arquivo"
                  
                  label="Novo arquivo do Boleto"
                  persistent-hint
                  accept=".pdf"
                  prepend-icon="mdi-file-pdf-outline"
                />
          </v-card-text>
          <v-card-actions>
            <v-btn depressed color="primary" @click="submit" :loading="loading"
              >Salvar</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ButtonDatepicker from "../components/ButtonDatepicker";

export default {
  mixins: [validationMixin],
  components: { ButtonDatepicker },
  validations: {
    dataParcela: { required },
  },

  data() {
    return {
      id: "",
      fatura: "",
      cliente: "",

      forma_pgto: "",
      loading: false,
      tituloNovo: true,
      id_empresa: "",
      arquivo: null,

      formaPgtoContaBancariaSelecionada: null,
      formaPgtoContaBancaria: [],

      menuDataParcela: false,
      data_parcela: "",
    };
  },

  computed: {
    dataParcela() {
      return this.data_parcela
        .split("-")
        .reverse()
        .join("/");
    },
    dataParcelaErrors() {
      const errors = [];
      if (!this.$v.dataParcela.$dirty) return errors;
      !this.$v.dataParcela.required &&
        errors.push("Data vencimento é Obrigatório.");
      return errors;
    },
  },

  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        const success = await this.$store.dispatch("contasReceber/gravar", {
          id: this.id,
          data_vencimento: this.data_parcela + "T00:00:00Z",
          id_forma_pagamento: this.formaPgtoContaBancariaSelecionada
            .id_forma_pagamento,
          id_conta_bancaria: this.formaPgtoContaBancariaSelecionada
            .id_conta_bancaria,
        });

        var arquivoBoleto = '';
        if(this.arquivo != null) {
            arquivoBoleto = this.arquivo;

            const dados = new FormData();
            dados.append("id", this.id);
            dados.append("arquivo", arquivoBoleto);
            await this.$store.dispatch("contasReceber/gravarBoleto", dados);
        } 

        this.loading = false;
        if (success) {
          this.$router.replace({ path: "lista", name: "contas-receber-list" });
        }
      }
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    dataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.substr(0, 10).split("-");
      return `${day}/${month}/${year}`;
    },
    dataSql(dataBR) {
      if (!dataBR) return null;

      const [day, month, year] = dataBR.split("/");
      return `${year}-${month}-${day}T00:00:00Z`;
    },
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de grupos de itens",
    });
    this.loading = true;
    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;
      this.tituloNovo = false;

      // CARREGAR DADOS DE FORMA PGTO + CONTA BANCARIA
      try {
        this.formaPgtoContaBancaria = [];
        const dados = await this.$store.dispatch("contaBancaria/retornaDados", {
          CarregarTudo: true,
          filtros: {
            id_empresa: parseInt(this.id_empresa),
          },
        });

        for (let item of dados) {
          for (let itemPgto of item.formas_pagamento) {
            const info = {
              id: item.id + "||" + itemPgto.id,
              id_conta_bancaria: item.id,
              descricao_conta_bancaria: item.descricao,
              agencia: item.agencia,
              conta: item.conta,

              id_forma_pagamento: itemPgto.id,
              descricao_forma_pagamento: itemPgto.descricao,
            };
            this.formaPgtoContaBancaria.push(info);
          }
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text:
            "Não foi possível carregar do dados Forma Pagamento e Conta Bancária",
        });
      }
      // =======================================

      try {
        var response = await this.$store.dispatch(
          "contasReceber/carregarContasReceber",
          id
        );
        this.id = response.data.id;
        this.fatura = response.data.documento;
        this.cliente = response.data.clientes.nome;
        this.data_parcela = response.data.data_vencimento.substr(0, 10);
        this.formaPgtoContaBancariaSelecionada =
          response.data.conta_bancaria.id +
          "||" +
          response.data.id_forma_pagamento;
        this.forma_pgto = response.data.forma_pagamento.descricao;
        this.id_empresa = response.data.id_empresa;

      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar do dados do contas a receber!",
        });
      }
    }
    this.loading = false;
  },
};
</script>
